import { Constants } from '..';
export class RfiCommonUtils {
    static isRfiApproved(doc) {
        const lastStatus = doc.status_history[doc.status_history.length - 1];
        return lastStatus?.state_id === Constants.SUBMITTAL_APPROVAL_STATUS_ID;
    }
}
